"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getTrueTagPosition_1 = __importDefault(require("../../../PrettyText/utils/getTrueTagPosition"));
const react_1 = require("react");
const useCreateCodeMirror_1 = __importDefault(require("./useCreateCodeMirror"));
const useImperativeCodeMirrorHandle_1 = __importDefault(require("./useImperativeCodeMirrorHandle"));
const useRegisterOnChangeWithCodeMirror_1 = __importDefault(require("./useRegisterOnChangeWithCodeMirror"));
const useUpdateCodeMirrorTags_1 = __importDefault(require("./useUpdateCodeMirrorTags"));
function useCodeMirror({ choiceGroups, initialValue, onChange, onClickTag, onEscape, placeholder, ref, textBoxRef, }) {
    const codeMirrorRef = react_1.useRef(null);
    const selectedTagPosRef = react_1.useRef(undefined);
    const onEscapeCallback = react_1.useCallback(onEscape, []);
    const onClickCodeMirrorTag = () => {
        if (codeMirrorRef.current) {
            const cursor = codeMirrorRef.current.getCursor();
            const pos = getTrueTagPosition_1.default(codeMirrorRef.current.getValue(), cursor);
            selectedTagPosRef.current = pos;
            if (pos) {
                onClickTag();
            }
            else {
                codeMirrorRef.current.setCursor(0);
            }
        }
    };
    const onClickTagCallback = react_1.useCallback(onClickCodeMirrorTag, []);
    useCreateCodeMirror_1.default({
        codeMirrorRef,
        initialValue,
        onEscape: onEscapeCallback,
        placeholder,
        selectedTagPosRef,
        textBoxRef,
    });
    useUpdateCodeMirrorTags_1.default({
        choiceGroups,
        codeMirrorRef,
        onClickTag: onClickTagCallback,
    });
    useRegisterOnChangeWithCodeMirror_1.default({
        choiceGroups,
        codeMirrorRef,
        onChange,
        onClickTag: onClickTagCallback,
    });
    useImperativeCodeMirrorHandle_1.default({
        choiceGroups,
        codeMirrorRef,
        onClickTag: onClickTagCallback,
        ref,
        selectedTagPosRef,
    });
}
exports.default = useCodeMirror;
